//@flow
import React from 'react';
import i18n from 'app/common/lib/i18n';
import { Box, Text } from 'gestalt';

type Props = {|
  buyableProduct: ?{
    display_active_max_price: string,
    display_active_min_price: string,
    is_available: boolean,
  },
  richSummary: {
    products: Array<{
      offer_summary?: {
        availability: number,
        price: string,
      },
    }>,
  },
  showProductInfo?: boolean,
|};

export default function PinPrice({ buyableProduct, showProductInfo, richSummary }: Props) {
  if (!showProductInfo) {
    return null;
  }
  let pinPrice;
  let pinAvailable;
  if (!!buyableProduct) {
    const {
      display_active_min_price: minPrice,
      display_active_max_price: maxPrice,
      is_available: isAvailable,
    } = buyableProduct;
    pinAvailable = isAvailable;
    pinPrice = minPrice === maxPrice ? minPrice : `${minPrice} - ${maxPrice}`;
  } else if (!!richSummary && (richSummary.products || []).length > 0) {
    const offerSummary = richSummary.products[0].offer_summary || {};
    const { availability, price } = offerSummary;
    pinPrice = price;
    if (availability === 1) {
      pinAvailable = true;
    } else if (availability === 2) {
      pinAvailable = false;
    }
  }

  return pinPrice ? (
    <Box display="flex" paddingY={1}>
      <Box marginRight={2}>
        <Text size="sm">{pinPrice}</Text>
      </Box>
      {pinAvailable !== undefined && (
        <Text size="sm" color={pinAvailable ? 'darkGray' : 'gray'}>
          {pinAvailable
            ? i18n._('In stock', 'A product Pin that is available')
            : i18n._('Out of stock', 'A product Pin that is out of stock')}
        </Text>
      )}
    </Box>
  ) : null;
}
